/**
 * whisperChips — the standard question-chip labels for The Whisper's Hand UI.
 *
 * ── WHY DUPLICATED ──────────────────────────────────────────────────────────
 * The canonical chip set lives in the ENGINE (`packages/engine/src/whisperWords.ts`
 * → `WHISPER_CHIPS`), bound to fact-card tag keys. The client must NEVER import
 * `@ringmaster/engine` (that package holds secrets — the word bank, `theWord`),
 * so we cannot re-export it. These labels are pure UI text (not secret): tapping
 * a chip simply fills the text box with the label and submits it via
 * `SUBMIT_WHISPER { text }` — the engine re-derives the tag from the text
 * (`chipToTag`, a loose keyword match), so the client only needs the strings.
 *
 * KEEP IN SYNC with `WHISPER_CHIPS` in the engine (label order + wording). If a
 * chip's label drifts from the engine's `chipToTag` keyword matcher, the tap
 * would fall through to the free-text path ("The Seer is silent") — harmless,
 * but the deterministic yes/no is lost, so mirror both together.
 */
export const WHISPER_CHIP_LABELS: readonly string[] = [
  'Is it alive?',
  'Bigger than a person?',
  'Found at night?',
  'Is it man-made?',
  'Does it have wings?',
  'Can you eat it?',
  'Is it found indoors?',
  'Does it make a sound?',
  'Is it found in nature?',
  'Does it have color?',
] as const;

/** Max characters per submission — mirrors the engine/zod cap (`text` max 30). */
export const WHISPER_MAX_CHARS = 30;

/** Max pending submissions per player before the engine drops new ones. */
export const WHISPER_PENDING_CAP = 3;
